import React from "react";
function Gdpr_Policy() {
    return (
        <>
            <section className="privacy-policy-sec sec">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="privacy-policy-txt-main">
                                <div className="privacy-policy-txt">
                                    <h2 className="text-center">GDPR Compliance Statement</h2>
                                    <p>
                                        <strong>The Design Showroom Ltd</strong> is committed to protecting your privacy and ensuring that your personal data is handled in accordance with the <strong>UK General Data Protection Regulation (UK GDPR)</strong>.</p>
                                </div>
                                <div className="privacy-policy-txt">
                                    <h2>Data Collection</h2>
                                    <p>
                                        We collect personal information that you provide voluntarily, including your name, contact details, and any other information necessary to process enquiries, orders, or provide services. We also collect limited technical data from your website usage, such as IP addresses and browser information, to improve your online experience.
                                    </p>
                                    <h2>Lawful Basis for Processing</h2>
                                    <p>We process personal data only where we have a lawful basis, which may include:</p>
                                    <div className="privacy-policy-list">
                                        <ul>
                                            <li>
                                                <p>
                                                    Consent: Where you opt-in to receive newsletters or marketing communications.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Contract: To fulfil our obligations for orders, services, or enquiries.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Legal Obligation: To comply with applicable laws and regulations.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Legitimate Interest: For internal business purposes, such as improving services and communications.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    <h2>Data Sharing</h2>
                                    <p>We do not sell your personal data. Your information may be shared only with trusted third-party partners, such as delivery or payment providers, where necessary to deliver our services.</p>
                                    <h2>Your Rights</h2>
                                    <p>Under GDPR, you have the right to:</p>
                                    <div className="privacy-policy-list">
                                        <ul>
                                            <li>
                                                <p>
                                                    Access, correct, or delete your personal data.
                                                </p>
                                            </li>
                                            <li><p>Restrict or object to processing.</p></li>
                                            <li><p>Withdraw consent at any time for marketing communications.</p></li>
                                            <li><p>Lodge a complaint with the Information Commissioner’s Office (ICO).</p></li>
                                        </ul>
                                    </div>
                                    <h2>Data Security and Retention</h2>
                                    <p>We implement strict security measures to protect your data from unauthorised access, loss, or misuse. Personal data is retained only as long as necessary to provide services or comply with legal obligations.</p>
                                    <div className="privacy-policy-txt">
                                        <h2>Contact Us</h2>
                                        <p>For GDPR-related enquiries, please contact:</p>
                                        <div className="privacy-policy-con">
                                            <h6>Email: </h6>
                                            <a href="mailto:sales@thedesignshowroom.com">sales@thedesignshowroom.com</a>
                                        </div>
                                        <div className="privacy-policy-con">
                                            <h6>Website: </h6>
                                            <a href="https://www.thedesignshowroom.com/">www.thedesignshowroom.com</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div></section>

        </>
    );
}

export default Gdpr_Policy;
